import React, { FC } from 'react';
import { useParams } from 'react-router';
import { TYPE_TEMPLATE_COMPONENTS } from './utils/templates';

const CashFlowListDetails: FC = () => {
  const { id } = useParams<{ id: string }>();

  const CustomForm = id !== null ? TYPE_TEMPLATE_COMPONENTS[id] : null;

  return (
    <div>
      {id !== null && TYPE_TEMPLATE_COMPONENTS[id] && <CustomForm id={id} /> }
    </div>
  );
};

export default CashFlowListDetails;
